/* global PRODUCTION */

// This depends on dataset attributes being added to an html element with an id
// of ``gtm-data``. Specifically, the attributes needed are:
// - id
// - params

// ===========================================================================
//
// ===========================================================================

// Setup Google Tag Manager
function init_gtm(
    global,
    layer,
    gtm_data,
    srcmap = s => {
        return s;
    }
) {
    let w = global;
    let d = global.document;
    let s = 'script';
    let l = layer;
    let i = gtm_data.id;

    w[l] = w[l] || [];
    w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
    });
    let f = d.getElementsByTagName(s)[0];
    let j = d.createElement(s);
    let dl = l !== 'dataLayer' ? `&l=${l}` : '';
    j.async = true;
    j.src = srcmap(`https://www.googletagmanager.com/gtm.js?id=${i}${dl}`);
    f.parentNode.insertBefore(j, f);
}

function qa_srcmap(gtm_data, src) {
    let params = gtm_data.params;
    let ret = `${src}${params}`;
    return ret;
}

// ===========================================================================
// main
// ===========================================================================

export function main() {
    let gtm_data = global.document.querySelector('#gtm-data').dataset;
    let srcmap_func = s => {
        return qa_srcmap(gtm_data, s);
    };
    let srcmap = PRODUCTION ? undefined : srcmap_func;
    init_gtm(global, 'dataLayer', gtm_data, srcmap);
}

// ===========================================================================
//
// ===========================================================================
